import React from "react";
import { SortableHandle } from "react-sortable-hoc";
import { MdDragHandle } from "react-icons/md";
import styled from "styled-components";

const Wrapper = styled.span`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: move;
`;

export const SortableDragHandle = SortableHandle(
  ({ size = 12, color }: { size?: number; color?: string }) => (
    <Wrapper>
      <MdDragHandle style={{ fontSize: size, color }} />
    </Wrapper>
  )
);
